module.exports = __webpack_public_path__ + "img/stripe.6bb6138f.png";